import { render, staticRenderFns } from "./planInquiry.vue?vue&type=template&id=522120ec&scoped=true"
import script from "./planInquiry.vue?vue&type=script&lang=js"
export * from "./planInquiry.vue?vue&type=script&lang=js"
import style0 from "./planInquiry.vue?vue&type=style&index=0&id=522120ec&lang=css"
import style1 from "./planInquiry.vue?vue&type=style&index=1&id=522120ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522120ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522120ec')) {
      api.createRecord('522120ec', component.options)
    } else {
      api.reload('522120ec', component.options)
    }
    module.hot.accept("./planInquiry.vue?vue&type=template&id=522120ec&scoped=true", function () {
      api.rerender('522120ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/planInquiry.vue"
export default component.exports